import { updateSentryOrganization } from './sentry';

let lastOrganizationName = null;

export const setupSentryStoreSubscriber = (store) => {
	// Subscribe to store changes to update Sentry organization context
	store.subscribe(() => {
		const state = store.getState();
		const organization = state?.header?.organization;
		const currentOrganizationName = organization?.name;

		// Only update Sentry if organization name has changed
		if (
			currentOrganizationName &&
			currentOrganizationName !== lastOrganizationName
		) {
			updateSentryOrganization(currentOrganizationName);
			lastOrganizationName = currentOrganizationName;
		}
	});
};
